import { CaseReducer, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AcademicYear } from 'data/academic-year/academic-year.modle';

type SliceState = {
  status: 'idle' | 'loading' | 'data' | 'error';
  data: AcademicYear[];
  error: any;
};

const initState: SliceState = {
  status: 'idle',
  data: [],
  error: false,
};

const setLoading = (): SliceState => ({ ...initState, status: 'loading' });

const setData: CaseReducer<SliceState, PayloadAction<AcademicYear[]>> = (_, action) => ({
  error: false,
  data: action.payload,
  status: 'data',
});

const setError: CaseReducer<SliceState, PayloadAction<any>> = (state, action) => ({
  error: action.payload,
  data: [],
  status: 'error',
});

const academicYearSlice = createSlice({
  name: 'academicYear',
  initialState: initState,
  reducers: {
    setLoading,
    setData,
    setError,
  },
});

export default academicYearSlice;
